import { render, staticRenderFns } from "./listarLeecheros.vue?vue&type=template&id=af075da2&scoped=true"
import script from "./listarLeecheros.vue?vue&type=script&lang=js"
export * from "./listarLeecheros.vue?vue&type=script&lang=js"
import style0 from "./listarLeecheros.vue?vue&type=style&index=0&id=af075da2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af075da2",
  null
  
)

export default component.exports